import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"


const initialState = { status: null, loading: false, data: [], error: "", message: '' }


export const userPayoutAction = createAsyncThunk(
    'user-payout',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/api/user-payout`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const userPayoutSlice = createSlice({
    name: 'user-payout',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(userPayoutAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(userPayoutAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(userPayoutAction.rejected, (state, action) => {
                state.loading = false
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.error = action?.payload?.message
            })
        },

})



export const userPayoutReducer = userPayoutSlice.reducer